import { become } from '@/apps/adok/entities/session'
import type { ImpersonationTicket } from '@/apps/adok/entities/session'

import { fetchAccount, readAccount } from './queries'

export type { ImpersonationTicket }

/**
 * Plain functions and not a composable: these run in the router's guards, outside any
 * component, where `useAccount()` cannot be called at all.
 *
 * `fetchQuery` on the key `useAccount()` reads, so the guard's request is the only one and
 * this is a no-op once the cache holds the answer. A failure is reported as `false`: "no
 * session" is what the guard acts on, and nothing here can tell that apart from any
 * other refusal.
 */
export async function ensureSession(): Promise<boolean> {
  try {
    await fetchAccount()

    return true
  } catch {
    return false
  }
}

export async function impersonate(ticket: ImpersonationTicket): Promise<void> {
  await become(ticket)
}

export function readStaffBadge(): { isStaff: boolean; accountId: number } {
  const account = readAccount()

  return {
    isStaff: !!account?.staff,
    accountId: Number(account?.id) || 0
  }
}
